import React, { JSX } from "react";

const RibbonSection = (
  props: {
    title?: string;
    children?: JSX.Element;
  }
) => {
  const { title, children } = props;
  return (
    <div id="ribbon-section">
      <div id="ribbon-section_header">
        { title && <h1> {title} </h1>}
      </div>

      {children}
    </div>
  )
}

export default RibbonSection;